import { t } from "i18next";

export const invoiceTypeId = {
    RegularInvoice: '1',
	ReversalInvoice: '2',
	SelfBilledInvoice: '3',
	AdvanceInvoice: '4',
} as const;

export type InvoiceTypeId = typeof invoiceTypeId[keyof typeof invoiceTypeId];

export function getInvoiceTypeDisplayNameById(id: InvoiceTypeId): string {
	return t(`entities:invoiceType.${id}`)
}

export function getShortInvoiceTypeDisplayNameById(id: InvoiceTypeId): string {
	return t(`entities:invoiceTypeShort.${id}`)
}